/**
 * Get the theme state
 * @category Core
 */ export var gridIsRtlSelector = function(state) {
    return state.isRtl;
};
